export default __webpack_public_path__ + "static/862-01b2a98cc4a5fe9793727e960a3d8865.gif";